import { render, staticRenderFns } from "./sendemailadd.vue?vue&type=template&id=36ec793c&scoped=true&"
import script from "./sendemailadd.vue?vue&type=script&lang=js&"
export * from "./sendemailadd.vue?vue&type=script&lang=js&"
import style0 from "./sendemailadd.vue?vue&type=style&index=0&id=36ec793c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ec793c",
  null
  
)

export default component.exports